import React from "react";

const Content = ({ content }) => {
  return (
    <div className="articleRender-container contentBlock">{content.text}</div>
  );
};

export default Content;
